import {
  Component,
  Input,
  Inject,
  PLATFORM_ID,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { PromotionModel } from '../../models';
import { isPlatformBrowser, NgClass } from '@angular/common';
@Component({
  selector: 'app-system-banner',
  templateUrl: './system-banner.component.html',
  styleUrls: ['./system-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class SystemBannerComponent implements OnInit {
  public showBanner = 'false';
  @Input() public promotions: PromotionModel[];

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  public ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (sessionStorage.getItem('closeBanner') === 'true') {
        this.showBanner = 'false';
      } else {
        this.showBanner = 'true';
      }
    }
  }

  public closeBanner(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showBanner === 'true') {
        this.showBanner = 'false';
        sessionStorage.setItem('closeBanner', 'true');
      }
    }
  }
}
